import { primaryColor } from '@zego/theme';

import generateTintTheme from './generateTintTheme';

export default generateTintTheme(primaryColor(11));
